<template>
    <modal
        ref="duplicateOrderModal"
        id="duplicate-order-modal"
        :centered="true"
        :title="$t('shop.duplicateOrderTitle')"
        :show="modal.show"
        :close="modal.close"
        :closeable="modal.closeable"
        @modal-close="onHideModal"
        :tighter-close-button="true"
        size="modal-lg"
    >
        <div class="modal-body pt-0">
            <p class="mb-0" v-html="$t('shop.duplicateOrderText')"></p>
            <br />
            <p v-for="duplicateOrder in duplicateOrders" :key="duplicateOrder.id">
                <b>#{{ duplicateOrder.id }}</b
                >: {{ duplicateOrder.validity_start_string
                }}<template v-if="duplicateOrder.validity_end_string">
                    - {{ duplicateOrder.validity_end_string }}</template
                >
            </p>
        </div>
        <div class="modal-footer justify-content-center">
            <button
                type="button"
                class="btn btn-primary"
                @click.prevent="ignoreDuplicate"
                v-html="$t('shop.duplicateOrderContinue')"
            ></button>
            <button
                type="button"
                class="btn btn-secondary"
                @click.prevent="onHideModal"
                v-html="$t('shop.duplicateOrderClose')"
            ></button>
        </div>
        <input type="hidden" name="ignore_duplicate" :value="ignore" />
    </modal>
</template>

<script>
export default {
    props: {
        duplicateOrders: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            ignore: false,
            modal: {
                show: false,
                close: false,
                closable: true,
            },
        };
    },

    methods: {
        /**
         * @returns {void}
         */
        onShowModal() {
            this.modal.close = false;
            this.modal.show = true;
        },

        /**
         * @returns {void}
         */
        onHideModal() {
            this.ignore = false;
            this.modal.show = false;
            this.modal.close = true;
        },

        ignoreDuplicate() {
            this.ignore = true;
            this.$nextTick(() => {
                this.onHideModal();
                this.$emit('continue');
            });
        },
    },
};
</script>
